import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from '../models/cnitem';
import { CNAnonymousReportRequest } from './cnanonymousreportrequest';
import { CNDocumentReportContent } from './cndocumentreportcontent';
import { CNDocumentReportDocument } from './cndocumentreportdocument';
import { SNItemFactory } from './snitemfactory';

@RegisterItem()
export class CNDocumentReport extends CNItem {

    private documentType: string;
    private document: CNDocumentReportDocument;
    private content: CNDocumentReportContent;

    public requests: CNAnonymousReportRequest[] = [];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDocumentReport';
        this.loaded.subscribe(myself => {
            const factory = new SNItemFactory();
            if (this.rawJson.content && this.rawJson.content.length > 0) {
                this.content = factory.itemFromJson(this.rawJson.content[0]);
                this.addChild(this.content, false);

            }
            if (this.rawJson.document && this.rawJson.document.length > 0) {
                this.document = factory.itemFromJson(this.rawJson.document[0]);
                this.addChild(this.document, false);
            }
        });
    }

    get templateName(): string {
        return this.getProperty('TemplateDescription');
    }

    get type(): string {
        if (!this.documentType && this.document) {
            try {
                this.documentType = this.document.value.split('.').pop().toLowerCase();
            } catch {
                this.documentType = 'none';
            }
        }
        return this.documentType;
    }

    get filename(): string {
        return '';
    }

    get requestRead(): boolean {
        if (!this.requests || this.requests.length === 0) {
            return false;
        }
        let foundRequestRead = false;
        this.requests.forEach(request => {
            if (request.getProperty('ReadStatus') === 'Read') {
                foundRequestRead = true;
            }
        });
        return foundRequestRead;
    }

    public clone(): any {
        return new CNDocumentReport();
    }
}

